import { useEffect, useState } from 'react';
import { Crown, ChevronRight } from 'lucide-react';
import api from '../../lib/api';
import { isPlayEnabled, firstName } from '../../lib/play';

export default function PlayLeaderChip({ group, onOpen }) {
  const [lb, setLb] = useState(null);
  const enabled = isPlayEnabled(group);
  useEffect(() => {
    if (!enabled || !group?.id) return;
    api.get(`/groups/${group.id}/play/leaderboard`).then((r) => setLb(r.data)).catch(() => {});
  }, [enabled, group?.id]);
  if (!enabled || !lb || !lb.players?.length) return null;
  const king = lb.players[0];
  return (
    <button type="button" onClick={onOpen} data-testid="play-leader-chip"
      className="w-full rounded-2xl border-2 border-amber-500/30 bg-gradient-to-r from-amber-500/10 to-background px-4 py-2.5 flex items-center gap-3 text-left hover:border-amber-500/60 transition-colors">
      <Crown className="w-5 h-5 text-amber-500 shrink-0" />
      <div className="flex-1 min-w-0">
        <p className="text-xs uppercase tracking-[0.16em] font-bold text-amber-700 dark:text-amber-300">
          {lb.season ? lb.season.name : 'All-time'} · King of the Court
        </p>
        <p className="font-semibold text-sm truncate">{firstName(king.name)} <span className="text-muted-foreground tabular-nums">· {king.rating} · {king.wins}W-{king.losses}L</span></p>
      </div>
      <ChevronRight className="w-4 h-4 text-muted-foreground" />
    </button>
  );
}
